export default function Privacidad() {
  return (
    <div className="legal-page font-sans max-w-3xl mx-auto px-6 py-16 text-slate-700">
      <a href="/" className="text-sm text-brand-blue font-medium">&larr; Volver a Conciliabanco</a>
      <h1 className="text-3xl font-extrabold text-navy-900 mt-4 mb-1">Política de privacidad</h1>
      <p className="text-sm text-slate-400 mb-8">Última actualización: 2026.</p>

      <div className="space-y-7 text-sm leading-relaxed">
        <p className="rounded-lg bg-amber-50 border border-amber-200 text-amber-800 px-4 py-3 text-xs">
          Este documento es un borrador funcional, no un texto certificado por un abogado.
          Antes de operar comercialmente, hazlo revisar por un abogado en Colombia.
        </p>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">1. Responsable del tratamiento</h2>
          <p>
            <strong>Andrés Usuga</strong>, operador de Conciliabanco, es responsable del
            tratamiento de los datos personales descritos en esta política, de acuerdo con la
            Ley 1581 de 2012 y el Decreto 1377 de 2013 de Colombia. Contacto:{' '}
            <a href="mailto:concilia@conciliabanco.com" className="text-brand-blue">concilia@conciliabanco.com</a>.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">2. Qué datos recolectamos</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Datos de registro: nombre, correo, cédula, celular, cargo, nombre y NIT de la empresa.</li>
            <li>Datos de facturación asociados al pago de la suscripción (procesados por Wompi; Conciliabanco no almacena el número completo de tarjeta).</li>
            <li>Los archivos que subes para conciliar (extractos bancarios y auxiliares contables) y los resultados generados.</li>
            <li>Datos de uso del sitio y, si están activados, datos de analítica web (Google Analytics) y de publicidad (Meta Pixel) — ver sección 6.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">3. Para qué usamos tus datos</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Prestar el servicio de conciliación bancaria y mantener tu historial.</li>
            <li>Gestionar tu cuenta, suscripción y facturación.</li>
            <li>Enviarte notificaciones operativas (resultado de conciliaciones, vencimientos de suscripción, recordatorios tributarios que actives).</li>
            <li>Mejorar el producto y, si has dado tu consentimiento, medir y optimizar campañas de mercadeo.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">4. Base legal y conservación</h2>
          <p>
            Tratamos tus datos para la ejecución del contrato de servicio que aceptas al
            registrarte, y con tu consentimiento para fines de mercadeo y analítica cuando
            aplique. Conservamos los datos de tu cuenta y tu historial de conciliaciones mientras
            tu cuenta esté activa, y por el tiempo adicional que exija la normativa contable o
            tributaria aplicable después de la cancelación.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">5. Con quién compartimos tus datos</h2>
          <p>
            No vendemos tus datos. Los compartimos únicamente con los proveedores necesarios para
            operar el servicio: la pasarela de pagos Wompi (para procesar tu suscripción) y el
            proveedor de hosting/infraestructura donde corre la aplicación. Estos proveedores solo
            acceden a los datos estrictamente necesarios para su función.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">6. Cookies y analítica</h2>
          <p>
            El sitio puede usar Google Analytics y Meta Pixel para entender el uso del landing y
            medir campañas — estas herramientas solo se activan si están configuradas por el
            operador, y recolectan datos de navegación agregados, no el contenido de tus
            conciliaciones.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">7. Tus derechos</h2>
          <p>
            Como titular de tus datos personales en Colombia tienes derecho a conocer, actualizar,
            rectificar y solicitar la eliminación de tus datos, así como a revocar tu
            consentimiento en cualquier momento. Para ejercer estos derechos escríbenos a{' '}
            <a href="mailto:concilia@conciliabanco.com" className="text-brand-blue">concilia@conciliabanco.com</a>{' '}
            indicando tu solicitud; responderemos dentro de los términos legales aplicables.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-navy-900 mb-2">8. Seguridad</h2>
          <p>
            Tu contraseña se almacena cifrada (nunca en texto plano) y el acceso a la plataforma
            requiere autenticación. Cada empresa registrada solo puede ver sus propios datos
            (aislamiento multi-empresa).
          </p>
        </section>
      </div>
    </div>
  );
}
